import { FLAG_COLORS, FlagColor, TypedObject } from "@multiweb/types/react";

/**
 * Pomocná funkce pro převod enum objektu na objekt.
 * Odfiltruje reverzní mapování číselných enumů a privátní atributy.
 *
 * @param enumObject Enum pro převod. Může být řetězcový i číselný.
 */
export const convertEnumToOptions = (enumObject: TypedObject<any>): TypedObject<any> => Object.keys(enumObject)
    .filter((key) => !key.match(/^\d+$/)) // Odfiltruje položky reverzního mapování z číselných enumů.
    .filter((key) => !key.startsWith("__")) // Odfiltruje privátní property, jako např. __docgenInfo vytvářené z komentářů.
    .filter((key) => key !== "displayName") // Odfiltruje displayName, který přidává react-docgen-typescript-loader, když má enum komentář.
    .reduce((result, key) => Object.assign({}, result, { [key]: enumObject[key] }), {});

/**
 * V zadaném objektu získá pro zadanou hodnotu její klíč. Pro nenalezenou hodnotu vrací undefined.
 * Vrací první nalezený klíč.
 *
 * @param options Objekt pro hledání klíče.
 * @param value Hodnota pro hledání klíče.
 */
export const convertValueToKey = <T>(options: TypedObject<T>, value: T): string | undefined => (
    Object.keys(options).find((key) => options[key] === value)
);

/**
 * Transformuje camelCase/UpperCamelCase na param-case
 * @param text camelCase/UpperCamelCase text k transformaci
 */
export const camelCaseToParamCase = (text: string): string => (
    text
        // UpperCamelCase to camelCase
        .replace(/^[A-Z]/g, (match) => match.toLowerCase())
        // camelCase to param-case
        .replace(/[A-Z]/g, (match) => "-" + match.toLowerCase())
);

/**
 * Ověří, zdali hodnota odpovídá typu *FlagColor*, případně zdali typu odpovídá
 * hodnota ve formátu *fBarva* upravena na *barva*. Pokud ano, vrátí hodnotu,
 * případně upravenou hodnotu. V opačném případě vrací undefined.
 * @param value Hodnota pro ověření.
 */
export const stringToFlagColorValue = (value: string | null | undefined): FlagColor | undefined => {
    if (!value) {
        return undefined;
    }

    if (FLAG_COLORS.includes(value.toLowerCase() as FlagColor)) {
        return value.toLowerCase() as FlagColor;
    }

    if (value.startsWith("f") && FLAG_COLORS.includes(value.substr(1).toLowerCase() as FlagColor)) {
        return value.substr(1).toLowerCase() as FlagColor;
    }

    return undefined;
};
